import { render } from "./AnnounceComponent.vue?vue&type=template&id=4f8c9c5c&scoped=true"
import script from "./AnnounceComponent.vue?vue&type=script&lang=js"
export * from "./AnnounceComponent.vue?vue&type=script&lang=js"

import "./AnnounceComponent.vue?vue&type=style&index=0&id=4f8c9c5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8c9c5c"]])

export default __exports__